import { Injectable, TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseControl, Custom, Textbox } from '@app/shared/dynamic-form';
import { isEmpty, result } from 'lodash';

export interface ConfigFields {
  tipo_finalizacion?: number;
  selectTypesTpl: TemplateRef<any>;
  selectStatusTpl: TemplateRef<any>;
  selectStatusExpedientTpl: TemplateRef<any>;
  selectAliasAssociationTaskTpl: TemplateRef<any>;
  selectDynamicViews: TemplateRef<any>;
  selectSedes: TemplateRef<any>;
  selectRolesTpl: TemplateRef<any>;
  selectTiggresTpl: TemplateRef<any>;
  parametros?: string[];
  selectParamsTpl: TemplateRef<any>;
  estado_tramite: number;
  estado_expediente: number;
  enviar_a_vista: number[];
  responsable_tarea_asociada: string;
  auto_guardado: string | false;
  validar_sede: number | false;
  id_opcion_saltar_area: number;
  grupos_responsables_asignacion: number | false;
  guardar_usuario_responsable_persistente: string | false;
  usuario_persistente: string | false;
  validar_jurisdiccion: boolean;
  triggers: number[];
  crear_rango_tiempo: boolean;
}

@Injectable()
export class FormService {
  constructor() { }

  /**
   * Retorna los controles para el formulario de la finalizacion
   *
   * @param {ConfigFields} obj
   * @param {(string | number)} index
   * @returns {BaseControl<any>[]}
   * @memberof FormService
   */
  getFields(obj: ConfigFields, index: string | number): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'tipo_finalizacion',
        label: 'Tipo de finalización:',
        order: 1,
        value: !result(obj, 'obj.tipo_finalizacion') ? obj.tipo_finalizacion : null,
        template: obj.selectTypesTpl,
        placeholder: 'Tipo de finalización de la tarea.',
        validations: {
          validators: [Validators.required]
        },
        idInput: 'tipo_finalizacion-' + index
      }),
      new Custom({
        key: 'parametros',
        label: 'Parametros:',
        order: 2,
        value: !isEmpty(obj.parametros) ? obj.parametros : [],
        template: obj.selectParamsTpl,
        placeholder: 'Opciones adicionales de la finalización.',
        idInput: 'parametros-' + index
      }),
      new Textbox({
        key: 'cambioEstado',
        label: 'Cambiar etapa del trámite',
        type: 'checkbox',
        order: 3,
        value: obj.estado_tramite ? true : false,
        idInput: 'cambioEstado-' + index
      }),
      new Custom({
        key: 'estado',
        label: 'Cambio etapa del tramite:',
        order: 4,
        value: obj.estado_tramite ? obj.estado_tramite : null,
        template: obj.selectStatusTpl,
        placeholder: 'Seleccione la etapa del trámite por el cual se desea cambiar.',
        condictions: [
          {
            campoDepende: 'cambioEstado',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'estado-' + index
      }),
      new Textbox({
        key: 'cambioEstadoExpediente',
        label: 'Cambiar estado del expediente',
        type: 'checkbox',
        order: 5,
        value: obj.estado_expediente ? true : false,
        idInput: 'cambioEstadoExpediente-' + index
      }),
      new Custom({
        key: 'estadoExpediente',
        label: 'Cambio estado del expediente:',
        order: 6,
        value: obj.estado_expediente ? obj.estado_expediente : null,
        template: obj.selectStatusExpedientTpl,
        placeholder: 'Seleccione el estado del expediente por el cual se desea cambiar.',
        condictions: [
          {
            campoDepende: 'cambioEstadoExpediente',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'estadoExpediente-' + index
      }),
      new Textbox({
        key: 'enviarVista',
        label: 'Enviar a vista',
        type: 'checkbox',
        order: 7,
        value: obj.enviar_a_vista ? obj.enviar_a_vista.length ? true : false : false,
        idInput: 'enviarVista-' + index
      }),
      new Custom({
        key: 'vistaDestino',
        label: 'Vista de destino:',
        order: 8,
        value: obj.enviar_a_vista ? obj.enviar_a_vista : null,
        template: obj.selectDynamicViews,
        placeholder: 'Seleccione La vista de destino.',
        condictions: [
          {
            campoDepende: 'enviarVista',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'vistaDestino-' + index
      }),
      new Textbox({
        key: 'responsableTareaAsociada',
        label: 'Asignar responsables de tarea asociada',
        type: 'checkbox',
        order: 9,
        value: obj['responsable_tarea_asociada'] ? true : false,
        idInput: 'responsableTareaAsociada-' + index
      }),
      new Custom({
        key: 'aliasAsociaciones',
        label: 'Alias de tareas asociadas:',
        order: 10,
        value: obj.responsable_tarea_asociada ? obj.responsable_tarea_asociada : null,
        template: obj.selectAliasAssociationTaskTpl,
        placeholder: 'Seleccione el alias de la tarea asociada.',
        condictions: [
          {
            campoDepende: 'responsableTareaAsociada',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'aliasAsociaciones-' + index
      }),
      new Textbox({
        key: 'autoGuardado',
        label: 'Auto guardado',
        type: 'checkbox',
        order: 11,
        value: obj.auto_guardado ? true : false,
        condictions: [
          {
            campoDepende: 'tipo_finalizacion',
            siEs: 'Igual',
            valor: !result(obj, 'obj.idOpcionSaltarTarea') ? obj.id_opcion_saltar_area : -1,
            accion: 'Mostrar'
          }
        ],
        idInput: 'autoGuardado-' + index
      }),
      new Textbox({
        key: 'txtMensajeEjecucion',
        label: 'Mensaje de ejecución:',
        order: 12,
        value: obj.auto_guardado ? obj.auto_guardado : null,
        placeholder: 'Mensaje para la carga de la ejecución del auto guardado.',
        condictions: [
          {
            campoDepende: 'autoGuardado',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar',
            operadorCondicion: 'Y'
          },
          {
            campoDepende: 'tipo_finalizacion',
            siEs: 'Igual',
            valor: !result(obj, 'obj.idOpcionSaltarTarea') ? obj.id_opcion_saltar_area : -1,
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'txtMensajeEjecucion-' + index
      }),
      new Textbox({
        key: 'validarSede',
        label: 'Validar dependencia',
        type: 'checkbox',
        order: 13,
        value: obj.validar_sede > 0 ? true : false,
        idInput: 'validarSede-' + index
      }),
      new Custom({
        key: 'cboSede',
        label: 'Dependencia de la validación:',
        order: 14,
        value: obj.validar_sede ? obj.validar_sede : null,
        template: obj.selectSedes,
        placeholder: 'Sede por la cual se realizará la validación de la finalización.',
        condictions: [
          {
            campoDepende: 'validarSede',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'cboSede-' + index
      }),
      new Textbox({
        key: 'asignarGrupoResponsable',
        label: 'Asignar grupo responsable',
        type: 'checkbox',
        order: 15,
        value: obj.grupos_responsables_asignacion ? true : false,
        idInput: 'asignarGrupoResponsable-' + index
      }),
      new Custom({
        key: 'cboGrupoResponsable',
        label: 'Grupo responsable:',
        order: 16,
        value: obj.grupos_responsables_asignacion ? obj.grupos_responsables_asignacion : null,
        template: obj.selectRolesTpl,
        placeholder: 'Seleccionar el grupo responsable.',
        condictions: [
          {
            campoDepende: 'asignarGrupoResponsable',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'grupoResponsable-' + index
      }),
      new Textbox({
        key: 'guardarResponsablePersistente',
        label: 'Guardar responsable persistente',
        type: 'checkbox',
        order: 17,
        value: obj.guardar_usuario_responsable_persistente ? true : false,
        idInput: 'guardarResponsablePersistente-' + index
      }),
      new Textbox({
        key: 'txtAliasGuardarResponsablePersistente',
        label: 'Alias responsable persistente:',
        order: 18,
        value: obj.guardar_usuario_responsable_persistente ? obj.guardar_usuario_responsable_persistente : null,
        placeholder: 'Ingrese el alias con el cual se guardara el responsable persistente.',
        condictions: [
          {
            campoDepende: 'guardarResponsablePersistente',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar',
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'txtAliasGuardarResponsablePersistente-' + index
      }),
      new Textbox({
        key: 'asignarResponsablePersistente',
        label: 'Asignar responsable persistente',
        type: 'checkbox',
        order: 19,
        value: obj.usuario_persistente ? true : false,
        idInput: 'asignarResponsablePersistente-' + index
      }),
      new Textbox({
        key: 'txtAliasUsuarioPersistente',
        label: 'Alias responsable persistente:',
        order: 20,
        value: obj.usuario_persistente ? obj.usuario_persistente : null,
        placeholder: 'Ingrese el alias con el cual esta guardado el responsable persistente.',
        condictions: [
          {
            campoDepende: 'asignarResponsablePersistente',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar',
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'txtAliasUsuarioPersistente-' + index
      }),
      new Textbox({
        key: 'validarJurisdiccion',
        label: 'Validar jurisdicción',
        type: 'checkbox',
        order: 21,
        value: obj.validar_jurisdiccion ? true : false,
        idInput: 'validarJurisdiccion-' + index,
        condictions: [
          {
            campoDepende: 'asignarGrupoResponsable',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar',
          }
        ],
      }),
      new Textbox({
        key: 'diparadores',
        label: 'Ejecutar disparadores',
        type: 'checkbox',
        order: 22,
        value: obj.triggers ? obj.triggers.length ? true : false : false,
        idInput: 'diparadores-' + index
      }),
      new Custom({
        key: 'cboDisparadores',
        label: 'Disparadores a ejecutar:',
        order: 23,
        value: obj.triggers ? obj.triggers : null,
        template: obj.selectTiggresTpl,
        placeholder: 'Seleccionar los disparadores a ejecutar.',
        condictions: [
          {
            campoDepende: 'diparadores',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
        idInput: 'grupoResponsable-' + index
      }),
      new Textbox({
        key: 'crearRangoTiempo',
        label: 'Crear rango de tiempos',
        type: 'checkbox',
        order: 23,
        value: obj.crear_rango_tiempo ? true : false,
        idInput: 'crearRangoTiempo-' + index
      }),
    ];
    // Ordenar los campos segun su propiedad order
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-completion/shared/form.service.ts